import lodash from 'lodash'

export function addNamespace (namespace, types) {
  return lodash.reduce(types, (typeObj, typeValue, typeName) => {
    typeObj[typeName] = lodash.reduce(typeValue, (obj, v, k) => {
      obj[k] = namespace + v
      return obj
    }, {})
    return typeObj
  }, {})
}



// WEBPACK FOOTER //
// ./src/app/shared/utils/NamespaceHelper.js